module.exports = __webpack_public_path__ + "static/media/5.9b70826d.jpg";